export default "__VITE_ASSET__14STkqFM__"